import { render, staticRenderFns } from "./ProfileBodysettings.vue?vue&type=template&id=0a3290cc&scoped=true"
import script from "./ProfileBodysettings.vue?vue&type=script&lang=js"
export * from "./ProfileBodysettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileBodysettings.vue?vue&type=style&index=0&id=0a3290cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3290cc",
  null
  
)

export default component.exports